import { RewardsQueryParams } from '@adminServices';
import { Reward } from '@klubovna/api-client';
import { createAction, props } from '@ngrx/store';
import { PaginationMetadata } from '@shared';

export const ADMIN_REWARDS_ID = '[Rewards admin]';

export const loadRewards = createAction(
  ADMIN_REWARDS_ID + ' Load Rewards',
  props<{ params?: RewardsQueryParams }>(),
);

export const loadRewardsSuccess = createAction(
  ADMIN_REWARDS_ID + ' Load Rewards Success',
  props<{ rewards: Reward[]; pagination: PaginationMetadata }>(),
);

export const loadRewardsFailure = createAction(
  ADMIN_REWARDS_ID + ' Load Rewards Failure',
  props<{ error: string }>(),
);

export const createReward = createAction(
  ADMIN_REWARDS_ID + ' Create Reward',
  props<{ rewardData: CreateRewardData }>(),
);

export const createRewardSuccess = createAction(
  ADMIN_REWARDS_ID + ' Create Reward Success',
  props<{ reward: Reward }>(),
);

export const createRewardFailure = createAction(
  ADMIN_REWARDS_ID + ' Create Reward Failure',
  props<{ error: string }>(),
);

export const updateReward = createAction(
  ADMIN_REWARDS_ID + ' Update Reward',
  props<{ id: string; rewardData: UpdateRewardData }>(),
);

export const updateRewardSuccess = createAction(
  ADMIN_REWARDS_ID + ' Update Reward Success',
  props<{ reward: Reward }>(),
);

export const updateRewardFailure = createAction(
  ADMIN_REWARDS_ID + ' Update Reward Failure',
  props<{ error: string }>(),
);

export const deleteReward = createAction(
  ADMIN_REWARDS_ID + ' Delete Reward',
  props<{ id: string }>(),
);

export const deleteRewardSuccess = createAction(
  ADMIN_REWARDS_ID + ' Delete Reward Success',
  props<{ id: string }>(),
);

export const deleteRewardFailure = createAction(
  ADMIN_REWARDS_ID + ' Delete Reward Failure',
  props<{ error: string }>(),
);

export interface CreateRewardData {
  name: string;
  description: string;
  costPoints: number;
  isActive?: boolean;
}

export interface UpdateRewardData {
  name?: string;
  description?: string;
  costPoints?: number;
  isActive?: boolean;
}
